import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import { Header } from './header';
import { BodyContent } from './bodycontent';
import { Footer } from './footer';

import styles from './modal.module.scss';

type modalProps = {
  clickOutToClose: any;
  size: any;
  onClose: any;
  className: any;
  style: any;
  iscustom: any;
  children: any;
};

type modalState = {
  open: any;
  size: string;
};


class Modal extends Component<modalProps, modalState> {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    className: PropTypes.string,
    onClose: PropTypes.func,
    clickOutToClose: PropTypes.bool,
    size: PropTypes.string,
    style: PropTypes.object,
    iscustom: PropTypes.any
   
  }

  // static defaultProps = {
  //   clickOutToClose: true,
  //   onClose: () => { }
  // }

  constructor(props:any) {
    super(props);
    this.state = {
      open: false,
      size: "default"
    };

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.listenKeyboard = this.listenKeyboard.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.listenKeyboard);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.listenKeyboard);
  }

  listenKeyboard(e:any) {
    let self:any=this;
    if (e.keyCode === 27 && this.props.clickOutToClose) {
      self?.close();
    }
  }

  handleClickOutside(event:any) {
    let self:any=this;
    event.stopPropagation();
    if (this.props.clickOutToClose) {
      self?.close();
    }
  }

  open = () => {
    this.setState({
      open: true,
      size: this.props.size
    });
  }

  close = () => {
    this.setState({ open: false }, this.props.onClose);
  }

  preventBubbling = (evt:any) => {
    evt.stopPropagation();
  }

  render() {
    const { children, className, style, iscustom } = this.props;
    const getClassName = () => {
      let className = styles.modalContainer;
      if (this.state.size) {
        className = `${className} ${styles[this.state.size]}`;
      }
      if (children.length === 2 && children[0].type.name === "Header") {
        className = `${className} ${styles.headerTypeModal}`;
      }
      if (children.length === 2 && children[0].type.name === "BodyContent") {
        className = `${className} ${styles.footerTypeModal}`;
      }
      return className;
    };
    return this.state.open ?
      createPortal(
        <div className={`${styles.modalWrapper} ${iscustom ? styles.isCustommodalWrapper : ''}`} style={style}
          data-name="modalContainer" onMouseDown={this.handleClickOutside}  >
          <div className={styles.modalInnerContainer}>
            <div className={`${className} ${getClassName()}`} onMouseDown={this.preventBubbling}>
              {
                children
              }
            </div>
          </div>
        </div>
        , document.body) :
      null;
  }
}

export { Modal, Header, BodyContent, Footer };